export default {
  formValidation: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  indicadores: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  questions: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  performanceManagement: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  filterRH: {},
  taskValuation: {
      loading: false,
      lastUpdate: null,
      data: [],
  },
  professionalQuestionsGoals: {
      loading: false,
      lastUpdate: null,
      data: [],
  },
  commercialEffort: {
      loading: false,
      lastUpdate: null,
      data: [],
  },
  // {{NEXT}}
}
